import React from 'react';

interface BusyProps {
    text: string;
}

export const BusyContainer: React.FunctionComponent<BusyProps> = ({ text }) => {
    return (
        <div className="relative">
            <div className="container">
                <div className="text">{ text }</div>
                <div className="rotate">
                    <div className="dot r1"></div>
                    <div className="dot r2"></div>
                    <div className="dot r3"></div>
                    <div className="dot r4"></div>
                    <div className="dot r5"></div>
                    <div className="dot r6"></div>
                </div>
            </div>
        </div>
    );
};